import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from 'react-admin';

const AzureStorageFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" />
    </Filter>
);

const AzureStorageList = props => (
    <List {...props} filters={<AzureStorageFilter />}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="account_name" />
            <TextField source="container" emptyText="-" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default AzureStorageList;